import request from '@/utils/request';

export const getWarehouseSwitchTime = async () => {
  const res = await request.get(
    '/api/v2/apps/config/wms_v2_update/get_warehouse_switch_time'
  );
  return res;
};
